
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.5 2C8.212 2 3.851 5.914 3.123 11H0l4 5.917L8 11H5.153c.711-3.972 4.174-7 8.347-7 4.687 0 8.5 3.813 8.5 8.5S18.187 21 13.5 21c-3.015 0-5.662-1.583-7.171-3.957l-1.2 1.775C7.045 21.354 10.077 23 13.5 23 19.297 23 24 18.298 24 12.5S19.297 2 13.5 2z"}})])
          )
        }
      }
    